<template>
  <module-configuration :data="config" :errors="errors" v-on:authenticated="getShippingMethods()">
    <div slot="auth" class="l-row">

      <form-group label="Ambiente" :required="true">
        <select v-model="config.auth.environment" class="form-select">
          <option value="sandbox">Sandbox</option>
          <option value="production">Produção</option>
        </select>
      </form-group>

      <form-group label="Token">
        <input class="form-input" v-model="config.auth.token">
      </form-group>
    </div>

    <panel :title="$t('quotation.label')">
      <div class="l-row">
        <form-group label="CEP de origem">
          <input class="form-input" type="text" v-model="config.quotation.zipCodeOrigin">
        </form-group>
      </div>
    </panel>

    <panel :title="$t('shippingMethods.label')">
      <div slot="header-right">
      <a href="#" @click="getShippingMethods()" class="btn btn--info"><i class="icon-spinner11"></i></a>
      </div>

      <loader :loading="loading"/>

      <panel :title="shippingMethods[carrierCode].name" v-for="carrierCode in Object.keys(shippingMethods)" :key="carrierCode"
             :useAcordion="true" :useToggleIcon="true" class="blue-panel">

        <panel>
          <div class="l-row" v-if="fetched">
            <form-group :label="service.ServiceDescription" v-for="service in shippingMethods[carrierCode].services" :key="service.ServiceCode">
              <select v-model="config.shippingMethods[service.ServiceCode]" class="form-select">
                <option :value="null">Selecione</option>
                <option v-for="shippingType in shippingTypes" :key="shippingType" :value="shippingType">{{ $t(`shippingTypes.${shippingType}.label`) }}</option>
              </select>
            </form-group>
          </div>

          <div v-else-if="!loading" class="u-bolder t-error u-textCenter">Não foi possível buscar as formas de envio da Frenet.</div>
        </panel>
      </panel>
    </panel>
  </module-configuration>
</template>

<script>
  import ModuleConfiguration from '@/views/Configuration/Shared'
  import FormGroup from '@/components/template/FormGroup'
  import Panel from '@/components/template/Panel'
  import Loader from '@/components/template/Loader'
  import api from '@/api'
  import notifier from '../../notifier'

  export default {
    provide: {
      moduleDI: {
        type: 'shipment',
        identifier: 'frenet'
      }
    },
    data: () => ({
      errors: [],
      type: 'shipment',
      identifier: 'frenet',
      loading: false,
      config: {
        auth: {
          environment: 'sandbox',
          token: null
        },
        quotation: {
          zipCodeOrigin: null
        },
        shippingMethods: {}
      },
      shippingMethods: {},
      shippingTypes: [
        'express',
        'standard',
        'economic'
      ]
    }),
    methods: {
      getShippingMethods () {
        this.loading = true
        api.getShippingMethods(this.identifier)
          .then(shippingMethods => {
            this.shippingMethods = []

            for (let i in shippingMethods) {
              const shippingMethod = shippingMethods[i]

              if (this.config.shippingMethods[shippingMethod.ServiceCode] === undefined) {
                this.config.shippingMethods[shippingMethod.ServiceCode] = null
              }

              if (this.shippingMethods[shippingMethod.CarrierCode] === undefined) {
                this.shippingMethods[shippingMethod.CarrierCode] = {
                  name: shippingMethod.Carrier,
                  services: [shippingMethod]
                }

                continue
              }

              this.shippingMethods[shippingMethod.CarrierCode].services.push(shippingMethod)
            }
          })
          .catch(() => {
            this.shippingMethods = []
            notifier.error('Falha ao buscar as modalidades de envio.', 'Frenet')
          })
          .finally(() => { this.loading = false })
      },
      fetched () {
        return this.shippingMethods.length
      }
    },
    components: {
      FormGroup,
      ModuleConfiguration,
      Panel,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Frenet.vue?55a8f1ad